import ParamsChecker from "../../ParamsChecker";
import Footer from "../footer/Footer";
import NewNavbar from "../newNavbar/NewNavbar";
import { ProductDiv } from "./ProductWrapperCSS";

export function ProductWrapper({ children, footerData, navbarData }) {
  return (
    <ProductDiv>
      <ParamsChecker />
      <NewNavbar data={navbarData} />
      {children}
      <Footer data={footerData}></Footer>
    </ProductDiv>
  );
}
